import { Adder } from './Adder/Adder';
import { Delay } from './Delay/Delay';
import { Scheduler } from './Scheduler/Scheduler';
import { Condition } from './Condition/Condition';
import { Dialogue } from './Dialogue/Dialogue';
import { UnicornDetector } from './UnicornDetector/UnicornDetector';
import { Zapier } from './Zapier/Zapier';
import { JSONWebhook } from './JSONWebhook/JSONWebhook';
import { MailChimp } from './MailChimp/MailChimp';

import { withMenu } from './elements/NodeMenu/NodeMenu';
import { withReviewBadge } from './elements/ReviewBadge/ReviewBadge';
import { GoogleSheet } from './GoogleSheet/GoogleSheet';

export const nodeTypes = {
  adder: Adder,
  condition: withReviewBadge(withMenu(Condition)),
  scheduler: Scheduler,
  delay: withMenu(Delay),
  dialogue: withReviewBadge(withMenu(Dialogue)),
  unicornDetector: withReviewBadge(withMenu(UnicornDetector)),
  zapier: withReviewBadge(withMenu(Zapier)),
  json_webhook: withReviewBadge(withMenu(JSONWebhook)),
  mailchimp: withReviewBadge(withMenu(MailChimp)),
  google_sheet: withReviewBadge(withMenu(GoogleSheet)),
};

export enum NodeTypes {
  ADDER = 'adder',
  CONDITION = 'condition',
  SCHEDULER = 'scheduler',
  DELAY = 'delay',
  DIALOGUE = 'dialogue',
  UNICORN_DETECTOR = 'unicornDetector',
  ZAPIER = 'zapier',
  JSON_WEBHOOK = 'json_webhook',
  MAILCHIMP = 'mailchimp',
  GOOGLE_SHEET = 'google_sheet',
}

export const getNode = (type: NodeTypes) => {
  switch (type) {
    case NodeTypes.CONDITION:
      return Condition;
    case NodeTypes.DELAY:
      return Delay;
    case NodeTypes.DIALOGUE:
      return Dialogue;
    case NodeTypes.SCHEDULER:
      return Scheduler;
    case NodeTypes.UNICORN_DETECTOR:
      return UnicornDetector;
    case NodeTypes.ZAPIER:
      return Zapier;
    case NodeTypes.JSON_WEBHOOK:
      return JSONWebhook;
    case NodeTypes.MAILCHIMP:
      return MailChimp;
    case NodeTypes.GOOGLE_SHEET:
      return GoogleSheet;
  }
};
